import _ from 'lodash-es';
import regions from '../../config/regions';

export default (country_code = 'US') => {
  let domain_found = false;

  _.each(regions, (country_codes, domain) => {
    if (country_codes.indexOf(country_code) > -1) {
      domain_found = domain;
    }
  });

  if (!domain_found) {
    _.each(regions, (country_codes, domain) => {
      if (country_codes === '*') {
        domain_found = domain;
      }
    });
  }

  return domain_found;
};
